import { useMutation } from "@tanstack/react-query";
import { useAppDispatch } from "../../../redux/hooks";
import { vaultApi } from "../../../api/vault.api";
import { setJWT } from "../../../redux/slices/vaultSlice";
import { setStoredVaultActorSession } from "../../../utils/vault/vaultActorSession";

export function useGenerateJWT() {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: ({ folderId, email }: { folderId: string; email: string }) =>
      vaultApi.generateJWT(folderId, email),
    onSuccess: (data, variables) => {
      setStoredVaultActorSession(variables.folderId, data.jwt_token);
      dispatch(setJWT(data.jwt_token));
    },
  });
}
